<script>
export default {
  name: 'SimplePlaceholder',
};
</script>

<template>
  <div class="h-6 w-48 bg-gray-200 rounded animate-pulse"></div>
</template>
